import React, { useEffect } from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import WhatAreWe from "./components/WhatAreWe";
import Outcomes from "./components/Outcomes";
import Services from "./components/Services";
import HowItWorks from "./components/HowItWorks";
import Portfolio from "./components/Portfolio";
import WhyChooseUs from "./components/WhyChooseUs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  // Call health check API once on page load
  useEffect(() => {
    const checkBackendHealth = async () => {
      try {
        const backendUrl = process.env.REACT_APP_API_URL || "http://localhost:8002";
        const response = await fetch(`${backendUrl}/api/health`);
        if (response.ok) {
          const data = await response.json();
          console.log("Backend health check passed:", data);
        } else {
          console.warn("Backend health check returned status:", response.status);
        }
      } catch (error) {
        console.warn("Backend health check failed:", error.message);
      }
    };

    checkBackendHealth();
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      <WhatAreWe />
      <Outcomes />
      <Services />
      <HowItWorks />
      <Portfolio />
      <WhyChooseUs />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
